import { cloneDeep, get, isObject } from "lodash";
import moment from "moment-timezone";
import React from "react";

import Button from "@/components/UI/Button";
import DatePicker from "@/components/UI/DatePicker";
import images from "@/utils/images";
import Input from "@/components/UI/Input";
import { Select, TextArea } from "@/components/UI/StyledInput";

import { DISCHARGE_SCHEMA } from "../../constants/discharge-schema";
import { dischargeDateExists } from "../../helpers/discharge-exists";

export function EditableDischarge(props) {
  const {
    classes,
    dateIndex,
    dischargeCount,
    dischargeValues,
    index,
    setDateIndex,
    setDischargeCount,
    setDischargeValues,
    setShowDischargeDatePickers,
    showDischargeDatePickers,
  } = props;

  const pickNoteDate = (dateStr, eventType) => {
    let parts = dateStr.split("-");
    let session_date = parts[1] + "/" + parts[2] + "/" + parts[0];

    setDischargeValue("discharge_date", session_date, dateIndex);
    const datePickers = showDischargeDatePickers;

    if (eventType !== "monthChange") {
      datePickers[dateIndex] = false;
    }
    setShowDischargeDatePickers(datePickers);
  };

  const setDischargeValue = (elementName, value, index) => {
    const currentDischargeValues = cloneDeep(dischargeValues);

    if (!isObject(currentDischargeValues[index])) {
      currentDischargeValues[index] = {};
    }

    currentDischargeValues[index][elementName] = value;
    setDischargeValues(currentDischargeValues);
  };

  const discharge = DISCHARGE_SCHEMA.map((formEl) => {
    if (formEl.elementType === "select") {
      return (
        <div
          className={classes && classes.colEditable ? classes.colEditable : "col-12 col-lg-7"}
          key={formEl.name + index}
        >
          <div className="FormGroup">
            <label className="Label">{formEl.elementConfig.label}</label>
            <Select
              changeHandler={(e) => setDischargeValue(formEl.name, e.target.value, index)}
              options={formEl.elementConfig.options}
              placeholder={{
                display: formEl.elementConfig.placeholder,
                value: formEl.elementConfig.placeholder,
              }}
              value={get(dischargeValues[index], [formEl.name], "")}
            />
          </div>
        </div>
      );
    } else if (formEl.elementType === "datepicker") {
      return (
        <div
          className={
            "d-flex " + (classes && classes.colEditable ? classes.colEditable : "col-8 col-lg-4")
          }
          key={formEl.name + index}
        >
          <div className="FormGroup" key={`fg${index}`}>
            <label className="Label">{formEl.elementConfig.label}</label>
            <div className="d-flex">
              <Input
                className="Input"
                disabled
                onChange={(e) => setDischargeValue(formEl.name, e.target.value, index)}
                placeholder={formEl.elementConfig.placeholder}
                value={get(dischargeValues[index], [formEl.name], "")}
              />
              <img
                className="ml-2 img-fluid"
                onClick={() => {
                  if (showDischargeDatePickers.includes(true)) {
                    return;
                  }
                  const datePickers = [...showDischargeDatePickers];

                  datePickers[index] = true;
                  setShowDischargeDatePickers(datePickers);
                  setDateIndex(index);
                }}
                src={images("./icons/calender-icon.svg")}
              />
            </div>
          </div>

          {showDischargeDatePickers[index] && (
            <div
              className="PrScheduleAvailability__DatePicker-wpr-absolute NoteDatePicker"
              key={`dp${index}`}
            >
              <div style={{ "margin-top": "80px" }}>
                <DatePicker
                  externalCtx={
                    dischargeDateExists(dischargeValues, index)
                      ? moment(dischargeValues[index]["discharge_date"], "MM/DD/YYYY")
                      : moment()
                  }
                  onDaySelect={pickNoteDate}
                />
              </div>
            </div>
          )}

          <div
            className="discharge-delete-button"
            key={`crossContainer${index}`}
            onClick={() => {
              if (index === 0) {
                return;
              }
              dischargeValues.splice(index, 1);
              showDischargeDatePickers.splice(index, 1);
              setDischargeCount(dischargeCount - 1);
              setDischargeValues(dischargeValues);
              setShowDischargeDatePickers(showDischargeDatePickers);
            }}
          >
            <img className="img-fluid" key={`cross${index}`} src={images("./icons/cross.svg")} />
          </div>
        </div>
      );
    } else if (formEl.elementType === "textarea") {
      return (
        <div
          className={classes && classes.colEditable ? classes.colEditable : "col-11"}
          key={formEl.name + index}
        >
          <div className="FormGroup">
            <label className="Label">{formEl.elementConfig.label}</label>
            <TextArea
              classes="Input"
              ids="Input"
              onChange={(e) => setDischargeValue(formEl.name, e.target.value, index)}
              placeholder={formEl.elementConfig.placeholder}
            />
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  });

  discharge.push(
    <Button
      className="col-6 ml-3 mb-4 new-discharge-button"
      key={index}
      onClick={() => {
        const datePickers = showDischargeDatePickers;

        datePickers.push(false);
        setDischargeCount(dischargeCount + 1);
        setShowDischargeDatePickers(datePickers);
      }}
      type="button"
    >
      Add new discharge date
    </Button>,
  );

  return discharge;
}
